import { inject, Service } from '@angular/core';
import { EventBusService } from '@shared';
import {
	HeaderConfigurationToHeader,
	PORTFOLIO_HEADER_EVENTS,
	PORTFOLIO_MENU_EVENT_ID
} from './portfolio-header-events.model';

/**
 * Portfolio → Header configuration producer.
 *
 * The holdings screen puts one control in the header: the three-dot menu the
 * handoff reaches تنظیمات پرتفوی through — on desktop and mobile alike.
 */
@Service({ autoProvided: false })
export class PortfolioHeaderEventProducerService {
	private readonly eventBus = inject(EventBusService);

	publishHeaderConfiguration(config?: HeaderConfigurationToHeader): void {
		this.eventBus.dispatch(PORTFOLIO_HEADER_EVENTS.HEADER_CONFIGURATION, config);
	}

	configurePortfolioHeader(): void {
		this.publishHeaderConfiguration({
			showLogo: true,
			headerLeftSectionItems: [
				{ iconName: 'menu-vertical', eventId: PORTFOLIO_MENU_EVENT_ID, ariaLabel: 'منوی پرتفوی' }
			]
		});
	}

	resetHeader(): void {
		this.publishHeaderConfiguration();
	}

	clearEventSnapshot(eventId: string): void {
		this.eventBus.clearSnapshot(PORTFOLIO_HEADER_EVENTS.HEADER_ACTION, eventId);
	}
}
